// extracted by mini-css-extract-plugin
module.exports = {"container":"zV-z","copyContainer":"AV-z"};